// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shiny-text {
  /* CSS variables with sensible defaults */
  --shine-color: hsl(0 0% 100% / 1);
  /* width of the highlight stripe */
  --shine-size: 3.5rem;
  /* total time to travel across once; JS will compute a precise value */
  --shine-duration: 2.5s;

  position: relative;
  display: inline-block;

  /* Base fill (current text color) + highlight stripe overlay */
  background-image:
    /* TOP: outer glow (blurred) */
    linear-gradient(
      90deg,
      transparent 0%,
      transparent 20%,
      var(--shine-color) 50%,
      transparent 80%,
      transparent 100%
    ),
    /* MIDDLE: concentrated core beam */
    linear-gradient(
        90deg,
        transparent 0%,
        transparent 40%,
        var(--shine-color) 50%,
        transparent 60%,
        transparent 100%
      ),
    /* BOTTOM: solid text color fill */
    linear-gradient(90deg, currentColor 0%, currentColor 100%);
  background-repeat: no-repeat, no-repeat, no-repeat;
  /* First two (stripes) use controllable width, third (fill) spans all */
  background-size:
    calc(var(--shine-size) * 2) 100%,
    var(--shine-size) 100%,
    100% 100%;
  background-position:
    calc(var(--shine-size) * -2) 0,
    0 0;

  /* Clip background to text */
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;

  animation: shiny-text-shine var(--shine-duration) ease-in-out infinite;
  will-change: background-position;
}

@keyframes shiny-text-shine {
  0% {
    background-position:
      calc(var(--shine-size) * -2) 0,
      calc(var(--shine-size) * -1) 0,
      0 0;
  }
  100% {
    background-position:
      calc(100% + var(--shine-size) * 2) 0,
      calc(100% + var(--shine-size)) 0,
      0 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .shiny-text {
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/embedded/chat/components/shiny-text/shiny-text.css"],"names":[],"mappings":"AAAA;EACE,yCAAyC;EACzC,iCAAiC;EACjC,kCAAkC;EAClC,oBAAoB;EACpB,sEAAsE;EACtE,sBAAsB;;EAEtB,kBAAkB;EAClB,qBAAqB;;EAErB,8DAA8D;EAC9D;;;;;;;;;;;;;;;;;;;;8DAoB4D;EAC5D,kDAAkD;EAClD,uEAAuE;EACvE;;;aAGW;EACX;;OAEK;;EAEL,4BAA4B;EAC5B,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;;EAEpC,sEAAsE;EACtE,gCAAgC;AAClC;;AAEA;EACE;IACE;;;SAGK;EACP;EACA;IACE;;;SAGK;EACP;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":[".shiny-text {\n  /* CSS variables with sensible defaults */\n  --shine-color: hsl(0 0% 100% / 1);\n  /* width of the highlight stripe */\n  --shine-size: 3.5rem;\n  /* total time to travel across once; JS will compute a precise value */\n  --shine-duration: 2.5s;\n\n  position: relative;\n  display: inline-block;\n\n  /* Base fill (current text color) + highlight stripe overlay */\n  background-image:\n    /* TOP: outer glow (blurred) */\n    linear-gradient(\n      90deg,\n      transparent 0%,\n      transparent 20%,\n      var(--shine-color) 50%,\n      transparent 80%,\n      transparent 100%\n    ),\n    /* MIDDLE: concentrated core beam */\n    linear-gradient(\n        90deg,\n        transparent 0%,\n        transparent 40%,\n        var(--shine-color) 50%,\n        transparent 60%,\n        transparent 100%\n      ),\n    /* BOTTOM: solid text color fill */\n    linear-gradient(90deg, currentColor 0%, currentColor 100%);\n  background-repeat: no-repeat, no-repeat, no-repeat;\n  /* First two (stripes) use controllable width, third (fill) spans all */\n  background-size:\n    calc(var(--shine-size) * 2) 100%,\n    var(--shine-size) 100%,\n    100% 100%;\n  background-position:\n    calc(var(--shine-size) * -2) 0,\n    0 0;\n\n  /* Clip background to text */\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n\n  animation: shiny-text-shine var(--shine-duration) ease-in-out infinite;\n  will-change: background-position;\n}\n\n@keyframes shiny-text-shine {\n  0% {\n    background-position:\n      calc(var(--shine-size) * -2) 0,\n      calc(var(--shine-size) * -1) 0,\n      0 0;\n  }\n  100% {\n    background-position:\n      calc(100% + var(--shine-size) * 2) 0,\n      calc(100% + var(--shine-size)) 0,\n      0 0;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .shiny-text {\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
